import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { FLUSH_DATA, FLUSH_LIST } from "../../../../Data/UiKit/Lists";
import { FlushList } from "../../../../Constant";
import { LI, UL } from "../../../../AbstractElements";

const FlushLists = () => {
  return (
    <Col xl="4" md="12">
      <Card>
        <CommonCardHeader title={FlushList} span={FLUSH_DATA} />
        <CardBody>
          <UL className="list-group-flush">
            <LI><i className="icofont icofont-arrow-right"> </i>PRODUCT</LI>
            {FLUSH_LIST.map((item, index) => (
              <LI key={index}><i className="icofont icofont-arrow-right"></i>{item}</LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default FlushLists;
